import { GetServerSideProps } from "next";
import Helmet from "@/components/Helmet";
import Header from "@/components/Layout/Header";
import ResponsiveWrap from "@/components/Layout/ResponsiveWrap";
import React, { useState } from "react";
import { getChapterList } from "./action";
import { EncryptTypeEnum, IChapterListPageTypes } from "./interfaces";
import Book from "../../read-ui/Book";
import {
  bookcover,
  chapterListUrl,
  composeChapterUrl,
  decodeChapterListUrl,
  isPureIdChapterListUrl,
} from "../../utils/URL";
import Cover from "../../read-ui/Cover";
import IconButton from "../../read-ui/IconButton";
import { SortOutline } from "@webnovel/chereads-icons";
import Icon from "../../read-ui/Icon";
import { BookTypeEnum } from "../../interface/IBook";
import ChapterItem from "./components/ChapterItem";
import { generateList, IRenderItem, getTDK } from "./utils";
import nodeUrl from "url";
import ChapterItems from "./components/ChapterItems";

export const getServerSideProps: GetServerSideProps = async (context) => {
  context.res.setHeader(
    "Cache-Control",
    "public, s-maxage=10, stale-while-revalidate=59"
  );
  const bookId = decodeChapterListUrl(context.resolvedUrl);
  if (!bookId) {
    throw new Error(`[error]Path is not valid: ${context.resolvedUrl}`);
  }

  try {
    const { data } = await getChapterList(
      {
        bookId,
        encryptType: EncryptTypeEnum.NORMAL,
      },
      context
    );

    if (
      !data.content ||
      data.content.bookInfo.checkLevel == 8 ||
      data.content.bookInfo.checkLevel == 9
    ) {
      return {
        notFound: true,
      };
    }

    const correctUrl = chapterListUrl({
      bookId,
      bookName: data.content.bookInfo.bookName,
      novelType: BookTypeEnum.Novel,
    });
    const { pathname, search } = nodeUrl.parse(context.resolvedUrl);
    const isPureId = isPureIdChapterListUrl(pathname!);
    if (pathname !== correctUrl && !isPureId) {
      // 非纯数字id的章节列表页才会重定向
      console.log("[redirect]Path is not valid: ", context.resolvedUrl);
      return {
        redirect: {
          destination: `${correctUrl}${search || ""}`,
          statusCode: 301,
        },
      };
    }
    return {
      props: {
        data: data.content,
        isPureId,
      },
    };
  } catch (e: any) {
    console.log("[error]", e.toString());
    return {
      redirect: {
        destination: "/",
        statusCode: 301,
      },
    };
  }
};

export default function ChapterListPage({
  data,
  isPureId,
}: {
  data: IChapterListPageTypes;
  isPureId: boolean;
}) {
  const { bookInfo, volumeItems, lastChapterItem, curReadChapter } = data;
  const { bookName = "", bookId } = bookInfo;
  const { title, description, keywords } = getTDK(
    bookName,
    bookInfo.description || ""
  );
  const coverUrl = bookcover(bookInfo.bookId, null, bookInfo.coverId);

  return (
    <>
      <Helmet
        title={title}
        keywords={keywords}
        description={description}
        bodyClassName={"bc_default"}
      />
      <h1 className="dn">{`Table of ${bookName}`}</h1>
      <Header />
      <ResponsiveWrap className={"pt16 pl16 pr16"} maxWidth={932}>
        <Book
          leftPart={<Cover src={coverUrl} width={52} />}
          title={bookName}
          subtitle={`${bookInfo.authorName} · ${bookInfo.categoryName}`}
          className={"pt12 pb12 pl12 pr12 br16 bc_fff"}
        >
          <a
            className={"pa w100% h100% t0 l0"}
            href={composeChapterUrl({
              bookId: bookInfo.bookId,
              bookName,
              novelType: BookTypeEnum.Novel,
              isPureId,
            })}
          >
            <span className={"dn"}>{bookName}</span>
          </a>
        </Book>
        <ChapterItems {...data} isPureId={isPureId} />
      </ResponsiveWrap>
    </>
  );
}
